import React from 'react';
import { connect } from 'react-redux';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Progress } from 'reactstrap';

import ItemUsage from './Usage';

function getColor(percent) {
  if (percent > 80) return 'success';
  if (percent > 50) return 'info';
  if (percent > 20) return 'secondary';
  return 'danger';
}

function PopularityBar(props) {
  const { item, t } = props;

  const percent = Math.round((item.popularity ?? 0) * 100);
  const color = getColor(percent);

  return (
    <>
      <ItemUsage item={item} />

      <Progress value={percent} color={color} style={{ height: '20px' }}>
        {percent}
        {'/100 '}
        {t('Popularity')}
      </Progress>
    </>
  );
}

PopularityBar.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  item: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(PopularityBar));
